import { render } from "./TemplateForm.vue?vue&type=template&id=1dc83c7a&scoped=true"
import script from "./TemplateForm.vue?vue&type=script&lang=js"
export * from "./TemplateForm.vue?vue&type=script&lang=js"

import "./TemplateForm.vue?vue&type=style&index=0&id=1dc83c7a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dc83c7a"]])

export default __exports__